import PopupsManager from "react-sdk/PopupsManager"
import AppState, { POPUPS, SCREENS } from "./AppState"

export default class LP_api {
  onFullscreen = false
  args = null
  registeredFunctions = {}

  getVars() {
    if(this.args.vars) return this.args.vars
    return {}
  }

  openSettings(onClose) {
    this.args = {onClose}
    PopupsManager.open(POPUPS.SETTINGS)
  }

  endGame(vars){
    this.args = vars
    window.top.postMessage("DEMO_END", "*");
    // AppState.setScreen(SCREENS.END_GAME)
  }
  getVertxClient(){
    return AppState.vertxClient
  }

  callFunction(name, param) {
    let ret = null

    switch(name) {
      case "goBackHome": AppState.setScreen(SCREENS.HOME); break;
      case "signalGameReady": AppState.handleGameReady(); break;
      case "openExternalLink": AppState.openLink(param); break;
    }

    return ret
  }

  toggleFullscreen() {
    if(this.onFullscreen){
      deactivateFullscreen()
      this.onFullscreen = false
    }
    else {
      activateFullscreen()
      this.onFullscreen = true
    }
  }

  openVideo(id, onClose) {
    this.args = {id, onClose}
    PopupsManager.open(POPUPS.VIDEO)
  }

  registerVirtualKeyboardEvent(callback) {
    if ('virtualKeyboard' in navigator) navigator.virtualKeyboard.addEventListener('geometrychange', callback)
  }

  registerFunction(name, func) {
    this.registeredFunctions[name] = func
  }
}



function activateFullscreen() {
  var isFullscreenAvailable = document.fullscreenEnabled;
  if(!isFullscreenAvailable) {
    console.log("fullscreen not authorized")
    return
  }
  window.document.documentElement.requestFullscreen()
}

function deactivateFullscreen() {
  var isFullscreenAvailable = document.fullscreenEnabled;
  if(!isFullscreenAvailable) {
    console.log("fullscreen not authorized")
    return
  }
  window.document.exitFullscreen()
}